import createConfigureStore from './configureStore';
import rootReducer from '../reducers/mobile/productPageReducer';

const isProd = process.env.NODE_ENV === 'production';
const configureStore = createConfigureStore(rootReducer, isProd);

export default configureStore;
